import { UnitOption } from '../components/unit-input/unit-input.component';

/**
 * Standard unit options for measurements throughout the application
 */

export const DISTANCE_UNITS: UnitOption[] = [
  { value: 'ft', label: 'Feet', shortLabel: 'ft' },
  { value: 'm', label: 'Meters', shortLabel: 'm' }
];

export const PRESSURE_UNITS: UnitOption[] = [
  { value: 'psi', label: 'PSI', shortLabel: 'psi' },
  { value: 'bar', label: 'Bar', shortLabel: 'bar' },
  { value: 'kPa', label: 'kPa', shortLabel: 'kPa' }
];

export const SPEED_UNITS: UnitOption[] = [
  { value: 'mph', label: 'Miles per hour', shortLabel: 'mph' },
  { value: 'kph', label: 'Kilometers per hour', shortLabel: 'kph' },
  { value: 'm/s', label: 'Meters per second', shortLabel: 'm/s' }
];

export const ALTITUDE_UNITS: UnitOption[] = [
  { value: 'ft', label: 'Feet', shortLabel: 'ft' },
  { value: 'm', label: 'Meters', shortLabel: 'm' }
];

export const VOLUME_UNITS: UnitOption[] = [
  { value: 'gal', label: 'Gallons', shortLabel: 'gal' },
  { value: 'L', label: 'Liters', shortLabel: 'L' },
  { value: 'qt', label: 'Quarts', shortLabel: 'qt' },
  { value: 'oz', label: 'Fluid Ounces', shortLabel: 'oz' }
];

export const TIME_INTERVAL_UNITS: UnitOption[] = [
  { value: 'hours', label: 'Hours', shortLabel: 'hrs' },
  { value: 'days', label: 'Days', shortLabel: 'days' },
  { value: 'minutes', label: 'Minutes', shortLabel: 'min' }
];

/**
 * Default units for US customers
 */
export const DEFAULT_UNITS = {
  distance: 'ft',
  pressure: 'psi',
  speed: 'mph',
  altitude: 'ft',
  volume: 'gal',
  timeInterval: 'hours'
};

/**
 * Default units for international customers
 */
export const DEFAULT_UNITS_METRIC = {
  distance: 'm',
  pressure: 'bar',
  speed: 'kph',
  altitude: 'm',
  volume: 'L',
  timeInterval: 'hours'
};
